import { useState } from "react";
import { useLang } from "@/context/LanguageContext";
import { api } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { ISLANDS } from "@/lib/translations";
import { Mail, Check } from "lucide-react";

export const NewsletterForm = ({ island, compact = false }) => {
  const { lang, t } = useLang();
  const [email, setEmail] = useState("");
  const [isl, setIsl] = useState(island || "");
  const [state, setState] = useState("idle");

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setState("busy");
    try {
      const r = await api.post("/newsletter/subscribe", { email, island: isl || null, lang });
      setState(r.data.status === "already" ? "already" : "sent");
    } catch { setState("error"); }
  };

  if (state === "sent" || state === "already") {
    return <div className={`flex items-center gap-2 text-sm ${compact ? "text-brand-deep justify-center" : "text-brand"}`} data-testid="newsletter-success"><Check className="w-4 h-4" />{state === "sent" ? t.newsletter.sent : t.newsletter.already}</div>;
  }

  return (
    <form onSubmit={submit} className={compact ? "" : "rounded-2xl bg-tint border border-line p-6 md:p-8"} data-testid="newsletter-form">
      {!compact && (
        <div className="mb-4">
          <div className="text-xs uppercase tracking-[0.3em] text-brand flex items-center gap-2"><Mail className="w-4 h-4" />{t.newsletter.badge}</div>
          <h3 className="font-serif text-2xl md:text-3xl text-stone-900 mt-2">{t.newsletter.title}</h3>
          <p className="text-sm text-stone-600 mt-2">{t.newsletter.text}</p>
        </div>
      )}
      {compact && <h3 className="font-serif text-2xl md:text-3xl text-brand-deep text-center mb-5">{t.newsletter.title}</h3>}
      <div className={`flex flex-col sm:flex-row gap-2 ${compact ? "max-w-2xl mx-auto" : ""}`}>
        <Input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder={t.newsletter.email} className="bg-white text-stone-900" data-testid="newsletter-email" />
        <select value={isl} onChange={(e) => setIsl(e.target.value)} aria-label={t.newsletter.allIslands} className="h-10 rounded-md border border-stone-300 px-3 text-sm bg-white text-stone-900" data-testid="newsletter-island">
          <option value="">{t.newsletter.allIslands}</option>
          {ISLANDS.map((i) => <option key={i} value={i}>{t.islands[i]}</option>)}
        </select>
        <Button type="submit" disabled={state === "busy"} className={`${compact ? "bg-footer-mid hover:bg-footer-dark uppercase tracking-widest text-xs font-bold px-6" : "bg-brand hover:bg-brand-hover"} text-white`} data-testid="newsletter-submit">{t.newsletter.submit}</Button>
      </div>
      {state === "error" && <p className="text-xs text-red-600 mt-2" data-testid="newsletter-error">{t.booking.error}</p>}
      <p className={`text-[11px] mt-3 ${compact ? "text-brand-deep text-center" : "text-stone-600"}`}>{t.newsletter.privacy}</p>
    </form>
  );
};
